import { useInfiniteQuery } from 'react-query';
import { JobService } from '../../../services/v1/applicant_tracking/JobService';
import { JobList } from '../../../entities/v1/JobList';

export const useInfiniteJobs = (enabled: boolean = true, name?: string) =>
  useInfiniteQuery<JobList>({
    queryKey: ['jobs', name],
    queryFn: async ({ pageParam }) => {
      const result = await JobService.list({ name, page: pageParam });

      return result;
    },
    getNextPageParam: (lastPage) => {
      return lastPage.nextPage ? lastPage.nextPage : undefined;
    },
    enabled: enabled,
  });
